// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"231":"feed","263":"widget","791":"video"}[chunkId] + "." + {"231":"c54800aa1e5d6ef4c904","263":"277171e71bc7c00f6946","791":"1dafba2ef6faf511ca41"}[chunkId] + ".js";
};